import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

/**
 * Pill button with trailing circular icon (design reference style).
 * variant: primary | dark | light | outline | outline-light
 * size: sm | md | lg
 */
const VARIANTS = {
  primary: "btn-pill btn-primary",
  dark: "btn-pill btn-dark",
  light: "btn-pill btn-light",
  outline: "btn-pill btn-outline",
  "outline-light": "btn-pill btn-outline-light",
};
const SIZES = { sm: "btn-sm", md: "", lg: "btn-lg" };

export const PillButton = ({ to, href, onClick, type = "button", variant = "primary", size = "md", icon: Icon = ArrowUpRight, children, className = "", testId, disabled, ...rest }) => {
  const cls = `${VARIANTS[variant] || VARIANTS.primary} ${SIZES[size] || ""} ${className}`;
  const inner = (
    <>
      <span>{children}</span>
      <span className="pill-icon"><Icon /></span>
    </>
  );
  if (to) return <Link to={to} className={cls} data-testid={testId} {...rest}>{inner}</Link>;
  if (href) return <a href={href} className={cls} data-testid={testId} target="_blank" rel="noopener noreferrer" {...rest}>{inner}</a>;
  return <button type={type} onClick={onClick} className={cls} data-testid={testId} disabled={disabled} {...rest}>{inner}</button>;
};
